import { render, staticRenderFns } from "./PoliticaCookies.vue?vue&type=template&id=1bcfcc4c&scoped=true"
import script from "./PoliticaCookies.vue?vue&type=script&lang=js"
export * from "./PoliticaCookies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfcc4c",
  null
  
)

export default component.exports